import BaseCardBehavior from './BaseCardBehavior';
import CardStateHelper, { getCardsState } from '../CardStateHelper';
import { BoosterType } from '../BoosterType';
import { CardTask } from '../CardTasks';
import { IGameState } from 'State/Game/IGameState';
import { CardState } from 'Prototype/Level/Card/CardState';

export default class CanisterPreBoosterCardBehavior extends BaseCardBehavior {
    public isPlayable(state: IGameState) {
        const cardsState = getCardsState(state);
        return this.cardID === cardsState.inStack[cardsState.inStack.length - 1];
    }

    public play(state: IGameState): IGameState {
        const currentCardState = CardStateHelper.getCardState(state, this.cardID);
        if (currentCardState === CardState.IN_STACK) {
            state = CardStateHelper.foldStackCard(state, this.cardID, {
                skipAnimation: true,
                preserveStreak: true,
            });
        }

        state = CardStateHelper.playBooster(state, BoosterType.TNT, {
            ignoreCost: true,
            flipCard: this.cardID,
            force: true,
        });

        state = CardStateHelper.setCardDiscarded(state, this.cardID);
        let cardsState = getCardsState(state);

        cardsState = CardStateHelper.checkCardsObscured(cardsState);

        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.USE_CANISTER_PRE_BOOSTER,
            cards: [this.cardID],
        });

        cardsState = CardStateHelper.clearUndoHistory(cardsState);

        // Update all cards behavior after some of them are discarded.
        state = CardStateHelper.updateGameState(state, cardsState);
        return CardStateHelper.updateCards(state);
    }
}
